import React, { useEffect, useState, useContext, useRef } from "react";
import useCeo from "../../hooks/useCEO";
import moment from "moment";
import "moment/locale/es-mx";
import { AuthContext } from "../../context/authContext/authContext";
import { SocketContext } from "../../context/SocketContext";
import { useUnidades } from "../../hooks/test/useUnidades";
import { Spinner } from "../../components/Spinner";
import { formatDate } from "../../helpers/formatDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHowler from "react-howler";
import sonidoAlerta from "../../assets/sounds/videoplayback.m4a";
import "react-datepicker/dist/react-datepicker.css";
import truckDark from "./../../assets/img/icons/truck-dark-icon.png";
import storeDark from "./../../assets/img/icons/store-dark-icon.png";
import TotalProtect from "./../../assets/img/logos/logoTPT.png";
import { SideCard } from "../../components/customFunctionalComponents/components/SideCardProtocols";
import { SidebarDetails } from "../../components/customComponents/Sidebar/SidebarDetails";
import { verifyJWT2 } from "../../helpers/JWT";
import { RegistrarEditarEventoRoboCamiones } from "../../components/customComponents/Modals/RegistrarEditarEventoRoboCamiones";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HistoricoEventosViaje } from "../../components/customComponents/Modals/HistoricoEventosViaje";
import { useJsApiLoader } from "@react-google-maps/api";
import Select from "react-select";
import {
  faList,
  faUserSecret,
  faFileLines,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

export const Tablero = () => {
  useCeo({
    title: "TABLERO GERENCIAL",
    description: "Página de tablero de rutas",
  });
  moment.locale("es-mx");
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY
      ? process.env.GOOGLE_MAPS_API_KEY
      : "AIzaSyD6ekb2qbmZ3p9qfsi56PfuUKQt71fMMHg", //"AIzaSyAUjS4TZ1KxdAe113gf698s2o4WYGf-byc"
  });
  const { user, negocioSeleccionado } = useContext(AuthContext);
  const [bitacoraUnidadades, setBitacoraUnidadades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectCedis, setSelectCedis] = useState([]);
  const [listaEstatus, setListaEstatus] = useState([]);
  const [actiModal, setActiModal] = useState(false);
  const [actiModalHistEvents, setActiModalHistEvents] = useState(false);
  const [idUnidad, setIdUnidad] = useState();
  const [idViaje, setIdViaje] = useState();
  // const [toast, addToast] = useState(0);
  const toaster = useRef();
  const { socket } = useContext(SocketContext);
  const [flag, setflag] = useState(false);
  const [unidad, setUnidad] = useState({});
  const [show, setShow] = useState(false);
  const [viaje, setViaje] = useState({});
  const [negocio_id, setNegocio_id] = useState();
  const [listaNegociosFull, setListaNegociosFull] = useState([]);
  const [negocioFilterOptions, setNegocioFilterOptions] = useState([]);

  const [showSideCardLeft, setShowSideCardLeft] = useState(false);
  const [sideCardLeftProtocolData, setSideCardLeftProtocolData] =
    useState(null);
  const [isLoadingProtocolDetails, setIsLoadingProtocolDetails] =
    useState(false); // Para la carga de detalles del protocolo
  const [errorProtocolDetails, setErrorProtocolDetails] = useState(null); // Para errores al cargar detalles del protocolo

  const toastId = React.useRef(null);
  const notify = () =>
    (toastId.current = toast("Alerta...", { autoClose: false }));
  const {
    getListaCedis,
    getListaEstatus,
    getUnidadesDinamicas,
    getUnidad,
    getViaje,
    getNegocios,
    getProtocolos,
    getGruposChat,
    getSeguimientoRegistrosSeguridad,
  } = useUnidades();
  const [form, setForm] = useState({
    status_id: "",
    unidad_numero: "",
    // cedis_id: "",
    selectedNegocios: [],
    selectedCedis: [],
  });

  const uniqueNegocioIds =
    user.cedis && Array.isArray(user.cedis)
      ? Array.from(new Set(user.cedis.map((cedi) => cedi.negocio_id))).filter(
          (id) => id !== undefined && id !== null
        )
      : [];

  useEffect(() => {
    if (selectCedis.length > 0 && listaNegociosFull.length > 0) {
      const accessibleNegocioIds = new Set(
        selectCedis.map((cedi) => cedi.negocio_id)
      );

      const negociosAccesibles = listaNegociosFull.filter((neg) =>
        accessibleNegocioIds.has(neg.negocio_id)
      );

      const options = negociosAccesibles.map((neg) => ({
        value: neg.negocio_id,
        label: neg.negocio_nombre,
      }));
      setNegocioFilterOptions(options);
    } else {
      // Aquí también deberías considerar un else if(!loading) como antes
      if (!loading) {
        setNegocioFilterOptions([]);
      }
    }
    // Las dependencias ya están correctas
  }, [selectCedis, listaNegociosFull, loading, user]);

  useEffect(() => {

    if (!socket) return;

    socket.on("bitacora_dinamica_", (data) => {
      if (user.roles_id === 2) {
        if (uniqueNegocioIds.includes(data.idNegocio)) loadData();
      } else if (data.idNegocio === user.negocio_id) {
        loadData();
        console.log("bitacora_dinamica_");
      }
    });

    console.log("detectando socket");

     socket.on("new_event_robo_", async (data) => {
      console.log("new event robo actualizando Unidades tablero");
      if (user.roles_id === 7 || user.roles_id === "7") showToastMessage();
      if (data.idNegocio === user.negocio_id || data.idNegocio === parseInt(negocioSeleccionado)) loadData();;
    });

    socket.on("Evento_del_bot_para_unidad_en_ruta", () => {
      console.log("Nuevo socket de apertura automatica");
      loadData();
    });

    return () => {
      socket.off("Evento_del_bot_para_unidad_en_ruta");
      socket.off("new_event_robo_");
      socket.off("bitacora_dinamica_");
    };
  }, [socket]);

  useEffect(() => {
    loadData();
  }, []);

  const copiarMensaje = async (id) => {
    let res = await getSeguimientoRegistrosSeguridad(id);
    if (res.ok) {

      const texto = generarMensaje(res.resumen);

      navigator.clipboard.writeText(texto)
        .then(() => {
          
          toast.success("Copiado para WhatsApp ✅");
        })
        .catch(() => {
          toast.error("Error al copiar");
        });
    } else {
      toast.error(res.msg ? res.msg :"Error al consultar los datos");
    }
    
  }
  
  const generarMensaje = (data) => {
    console.log(data);
    const tieneDispositivo = (valor) => {
      return String(valor).trim().toLowerCase() === 'si' ||
            String(valor).trim().toLowerCase() === 'sí';
    };

    return `*Asunto: ${data.asunto}* ${data.mercancia ? ", Con mercancía" : ", Sin mercancía,"}

    *Entidad:* ${data.entidad}
    *Cliente:* ${data.cliente}

    *Origen:* ${data.origen}
    *Destino:* ${data.destino}

    *Fecha y Hora:* ${data.fecha_hora}

    *Dirección:*
    ${data.direccion}

    *Ubicación:*
    ${data.link}

    *Unidad:*
    Económico: ${data.unidad.economico}
    Placas: ${data.unidad.placas}
    Serie: ${data.unidad.serie}
    Marca: ${data.unidad.marca}
    Submarca: ${data.unidad.submarca}
    Modelo: ${data.unidad.modelo}
    Color: ${data.unidad.color}

    ${data.cajas && data.cajas.length > 0 
      ? `*Cajas secas:*
    ${data.cajas.map((caja, index) => `
      ${index + 1}. Económico: ${caja.economico}
      Placas: ${caja.placas}
      Serie: ${caja.serie}
      Marca: ${data.unidad.marca}
      Submarca: ${data.unidad.submarca}
      Modelo: ${data.unidad.modelo}
      Color: ${data.unidad.color}
    `).join('')}`
      : ''
    }

    *Operador:*
    ${data.operador}

    *Tripulante:*
    ${data.tripulante}

    *Nota:*
    ${data.nota}

    *Dispositivos:*
    GPS: ${tieneDispositivo(data.gps) ? '✅' : '❌'}
    Botón de pánico: ${tieneDispositivo(data.boton_panico) ? '✅' : '❌'}
    Paro de motor: ${tieneDispositivo(data.paro_motor) ? '✅' : '❌'}
    AS3: ${tieneDispositivo(data.as3) ? '✅' : '❌'}
    MDVR: ${tieneDispositivo(data.mdvr) ? '✅' : '❌'}
    Cerradura: ${tieneDispositivo(data.cerradura) ? '✅' : '❌'}
    `;
  }

  const handleBusinessFilterChange = (selectedOptions) => {
    setForm((prevForm) => ({
      ...prevForm,
      selectedNegocios: selectedOptions || [],
    }));
  };

  const handleCedisFilterChange = (selectedOptions) => {
    // selectedOptions es un array de objetos { value, label } si isMulti
    setForm((prevForm) => ({
      ...prevForm,
      selectedCedis: selectedOptions || [], // <-- CORRECTO: Actualizar selectedCedis
    }));
    // La lógica de filtrado se ha movido a filterUnidad
  };

  const modalClose = async () => {
    setLoading(true);
    setActiModal(false);
    await loadData();
    setLoading(false);
  };

  const modalCloseHistEvents = async () => {
    setActiModalHistEvents(false);
  };

  const loadData = async () => {
    setLoading(true);

    const { rolId } = verifyJWT2(localStorage.getItem("x-token"));

    //Se obtiene la lisgta de CEDIS a la que el usuario tiene acceso
    if (rolId === 2) {
      // Si el usuario es 2 los CEDIS se obtienen de las variables de sesion
      let resp = localStorage.getItem("cedis")
        ? JSON.parse(localStorage.getItem("cedis"))
        : [];
      console.log(resp.negocio_id);
      setSelectCedis([...resp]);

      const [cedis] = JSON.parse(localStorage.getItem("cedis"));
      const negocio = cedis.negocio_id;
      if (negocio) {
        setNegocio_id(negocio);
      }
    } else {
      let resp = await getListaCedis();

      if (resp.ok) {
        // Si el usuario es 1 los CEDIS se filtran por el negocio_id del usuario
        const cedisFiltrados =
          user.roles_id === 1
            ? resp.cedis.filter((x) => x.negocio_id === user.negocio_id)
            : resp.cedis;
        setSelectCedis(cedisFiltrados);
      }

      if (user.negocio_id) {
        setNegocio_id(user.negocio_id);
      }
    }

    try {
      const respNegocios = await getNegocios();
      if (respNegocios.ok && respNegocios.negocios) {
        setListaNegociosFull(respNegocios.negocios);
      } else {
        console.error("Error al llamar a getNegocios", respNegocios);
        setListaNegociosFull([]);
      }
    } catch (error) {
      console.error("Error al llamar a getNegocios", error);
      setListaNegociosFull([]);
    }

    let resp = await getUnidadesDinamicas();
    if (resp.ok) {
      setBitacoraUnidadades(resp.bitacoras);
    }

    resp = await getListaEstatus();
    if (resp.ok) setListaEstatus(resp.estatus);

    setLoading(false);
  };

  const getDetails = (unidad_id, id_viaje) => {
    setflag(!flag);
    setLoading(true);
    selectUnidad(unidad_id, id_viaje);
  };

  const selectUnidad = async (unidad_id, viaje_id) => {
    let resp = await getUnidad(unidad_id);
    if (resp.ok) {
      setUnidad({ ...resp.unidad });
      setShow(true);
      setLoading(false);
      getViajeId(viaje_id);
    } else {
      setLoading(false);
    }
  };

  const getViajeId = async (viaje_id) => {
    let resp = await getViaje(viaje_id);
    if (resp.ok) setViaje(resp);
  };

  const hideSidebar = () => {
    setShow(false);
  };

  const handleShowSideCardLeft = async (bitacoraItem) => {
    // console.log("[Tablero] --- Iniciando handleShowSideCardLeft para CEDIS:", bitacoraItem.CEDIS, "---");
    // console.log("[Tablero] bitacoraItem recibido para SideCard:", bitacoraItem);

    // Asumiendo que bitacoraItem tiene cedis_id
    const cedisId = bitacoraItem.cedis_id;
    if (!cedisId) {
      toast.info("No se encontró el ID del CEDIS para este evento.");
      return;
    }

    setIsLoadingProtocolDetails(true);
    setErrorProtocolDetails(null);

    try {
      const protocoloResp = await getProtocolos(cedisId);
      // console.log("[Tablero] Respuesta de getProtocolos para SideCard:", protocoloResp);

      if (protocoloResp.ok && protocoloResp.protocolo) {
        const gruposResp = await getGruposChat(cedisId);
        // console.log("[Tablero] Respuesta de getGruposChat para SideCard:", gruposResp);

        const fullProtocolData = {
          // El protocolo_id viene de protocoloResp.protocolo.protocolo_id
          id: protocoloResp.protocolo.protocolo_id,
          titulo_protocolo:
            protocoloResp.protocolo.titulo_protocolo || "Sin Título",
          evento_riesgo: protocoloResp.protocolo.evento_riesgo || "",
          cedis_id: cedisId,
          cedisNombre: bitacoraItem.CEDIS, // Usar el nombre del CEDIS de la bitácora
          escalamientos: protocoloResp.protocolo.protocolo_escalamientos || [],
          grupos_mensajeria:
            gruposResp.ok && gruposResp.grupos ? gruposResp.grupos : [],
        };
        setSideCardLeftProtocolData(fullProtocolData);
        setShowSideCardLeft(true);
      } else {
        toast.info(
          protocoloResp.msg ||
            "Este CEDIS no tiene un protocolo configurado para mostrar detalles."
        );
        setErrorProtocolDetails(
          new Error(
            protocoloResp.msg ||
              "Error desconocido al cargar detalles del protocolo para SideCard."
          )
        );
      }
    } catch (error) {
      console.error(
        "Error al obtener detalles del protocolo o grupos de chat para SideCard:",
        error
      );
      toast.error("Ocurrió un error al cargar los detalles para el SideCard.");
      setErrorProtocolDetails(error);
    } finally {
      setIsLoadingProtocolDetails(false);
    }
  };

  const handleHideSideCardLeft = () => {
    // console.log("[Tablero] Ocultando SideCard izquierdo.");
    setShowSideCardLeft(false);
    setSideCardLeftProtocolData(null);
  };

  const calculoHora = (horaUltimaActualizacion) => {
    // console.log("horaUltimaActualizacion: " +horaUltimaActualizacion);
    let fecha1 = moment().format("YYYY-MM-DD HH:mm:ss");
    fecha1 = new Date(fecha1).getTime();

    // console.log("fecha1: " + fecha1);
    let fecha2 = moment(horaUltimaActualizacion)
      .local()
      .format("YYYY-MM-DD HH:mm:ss");
    fecha2 = new Date(fecha2).getTime();
    // console.log("fecha2: " + fecha2);
    let milisegundos = fecha1 - fecha2;
    let dias = Math.trunc(milisegundos / (1000 * 60 * 60 * 24));
    // console.log("Diff in days: " + dias);
    let minutes = Math.trunc(milisegundos / (1000 * 60));
    // console.log("minutes: "+minutes);
    // minutes = minutes * -1;

    if (minutes <= 40) return "green";
    if (minutes >= 41 && minutes <= 60) return "yellow";
    if (minutes >= 61 && minutes <= 90) return "orange";
    if (minutes > 90) return "red";
    return "black";
  };

  const filterUnidad = () => {
    // Siempre empezamos el filtro con el conjunto original de unidades cargadas.
    let unidadesFiltradas = bitacoraUnidadades;

    // --- Aplicar filtro por NEGOCIO seleccionado (NUEVO) ---
    // form.selectedNegocios es un array de objetos { value: negocio_id, label: nombre }
    if (form.selectedNegocios && form.selectedNegocios.length > 0) {
      const selectedNegocioIds = form.selectedNegocios.map(
        (option) => option.value
      ); // Obtener los IDs de negocio seleccionados
      unidadesFiltradas = unidadesFiltradas.filter(
        (unidad) =>
          // Filtrar unidades si su negocio_id está en la lista de IDs seleccionados
          unidad.negocio_id !== undefined &&
          selectedNegocioIds.includes(unidad.negocio_id)
      );
    }

    // --- Aplicar filtro por CEDIS seleccionado ---
    // form.selectedCedis es un array de objetos { value: cedis_id, label: nombre }
    if (form.selectedCedis && form.selectedCedis.length > 0) {
      const selectedCedisIds = form.selectedCedis.map((option) => option.value); // Obtener los IDs de CEDIS seleccionados
      unidadesFiltradas = unidadesFiltradas.filter(
        (unidad) =>
          // Filtrar unidades si su cedis_id está en la lista de IDs seleccionados
          unidad.cedis_id !== undefined &&
          selectedCedisIds.includes(unidad.cedis_id)
      );
    }

    // --- Aplicar filtro por ESTATUS seleccionado ---
    if (form.status_id !== "") {
      // Si se ha seleccionado un estatus específico
      const statusIdNum = parseInt(form.status_id);
      if (!isNaN(statusIdNum)) {
        unidadesFiltradas = unidadesFiltradas.filter(
          (unidad) => unidad.ultimoEvento === statusIdNum
        );
      }
    }

    // --- Aplicar filtro por NÚMERO DE UNIDAD ---
    if (form.unidad_numero) {
      unidadesFiltradas = unidadesFiltradas.filter(
        (unidad) =>
          unidad.numero_unidad &&
          unidad.numero_unidad.includes(form.unidad_numero)
      );
    }

    // Devolvemos la lista filtrada final
    return unidadesFiltradas;
  };

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    setForm((prevForm) => ({
      // Usar el patrón con prevForm es más seguro con async updates
      ...prevForm,
      [name]: name === "status_id" ? parseInt(value) : value,
    }));
  };

  const showToastMessage = () => {
    // toast.error("Error", { autoClose: false });
    notify();
    toast.update(toastId.current, {
      type: toast.TYPE.ERROR,
      render: () => (
        <>
          <div className="fw-bold me-auto">
            &nbsp;--¡ALERTA!--{" "}
            <small>{moment().format("YYYY-MM-DD HH:mm:ss")}</small>
          </div>
          <ReactHowler src={sonidoAlerta} playing={true} />
        </>
      ),
      autoClose: false,
    });
  };

  const filterCedis = async (cedisFiltrar) => {
    if (cedisFiltrar.length === 0) {
      let resp = await getUnidadesDinamicas();
      if (resp.ok) setBitacoraUnidadades(resp.bitacoras);
    } else {
      const nombresExtraidos = cedisFiltrar.map((cedi) => cedi.label);
      let resp = await getUnidadesDinamicas();
      let filtrados;
      if (resp.ok)
        filtrados = resp.bitacoras.filter((numero) =>
          nombresExtraidos.includes(numero.CEDIS)
        );
      setBitacoraUnidadades(filtrados);
    }
  };

  return (
    <>
      {loading && <Spinner />}
      {/* <button onClick={() => showToastMessage()}>click</button>
      <button onClick={() => socket.emit("new_event_robo")}>new_event_robo</button>socket */}
      {/* <ToastContainer
        toastStyle={{
          backgroundColor: "rgb(135 47 47)",
          color: "#fff",
          textAlign: "center",
        }}
      /> */}
      <div className="px-3">
        <div
          className="py-3 mx-auto text-center card mb-3"
          style={{
            position: "fixed",
            width: "98.3%",
            right: "16px",
            zIndex: 100,
            top: "58px",
            height: "146px",
          }}
        >
          <div className="col-12">
            {user.roles_id === 1 ? (
              <img
                src={
                  process.env.REACT_APP_API_URL_LOCAL +
                  `negocios/${negocio_id}/bg`
                }
                className="img-fluid"
                style={{ maxWidth: "250px" }}
                alt=""
              />
            ) : (
              <img
                src={TotalProtect}
                className="img-fluid"
                style={{ maxWidth: "250px" }}
                alt=""
              />
            )}
          </div>
        </div>
        <div
          className="card"
          style={{
            position: "fixed",
            width: "98.3%",
            right: "16px",
            zIndex: 100,
            top: "204px",
          }}
        >
          <div className="row d-flex align-items-center">
            {/* Primer Select: SELECCIONAR NEGOCIOS (Asegurar props correctas) */}
            {user && user.roles_id === 2 && (
              <div className="col-sm-6 col-md-3 py-3 mx-auto ">
                <Select
                  options={negocioFilterOptions} // Usa las opciones generadas
                  isMulti
                  className="form-control selectCedis"
                  classNamePrefix={"select"}
                  value={form.selectedNegocios} // Usa el estado del form para negocios
                  onChange={handleBusinessFilterChange} // Usa el manejador correcto para negocios
                  placeholder="Selecciona los negocios"
                  isClearable
                  // AÑADIDO: loading y disabled states para mejor UX
                />
              </div>
            )}
            {/* Segundo Select: SELECCIONAR CEDIS (MODIFICADO) */}
            <div className="col-sm-6 col-md-3 py-3 mx-auto ">
              <Select
                options={selectCedis.map((x) => {
                  return { value: x.cedis_id, label: x.nombre_cedis }; // Mapear CEDIS a { value: id, label: nombre }
                })}
                isMulti // Permite seleccionar múltiples CEDIS
                className="form-control selectCedis"
                classNamePrefix={"select"}
                value={form.selectedCedis} // <<< Usar el estado del form para los cedis seleccionados
                onChange={handleCedisFilterChange} // <<< Usar el manejador para cedis
                placeholder="Selecciona los cedis"
                isClearable // Permite limpiar la selección
              />
            </div>

            <div className="col-sm-6 col-md-3 py-3 mx-auto">
              <select
                value={form.status_id}
                className="form-control styled-select selectCedis"
                name="status_id"
                onChange={handleChange1}
                required
              >
                <option value="">TODOS LOS EVENTOS</option>
                {listaEstatus.map((x) => (
                  <option value={`${x.status_id}`} key={x.status_id}>
                    {x.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-sm-6 col-md-3 py-3 mx-auto">
              <input
                name="unidad_numero"
                placeholder="BUSCAR UNIDAD"
                className="form-control selectCedis"
                onChange={handleChange1}
              />
            </div>
          </div>
        </div>
        {show && (
          <SidebarDetails
            flag={flag}
            hideSidebar={hideSidebar}
            unidad={unidad}
            viaje={viaje}
          ></SidebarDetails>
        )}
        <div className="pt-1" style={{ marginTop: "245px" }}>
          {filterUnidad().length > 0 ? (
            filterUnidad().map((bitacora, index) => {
              // let btas = Array.from(bitacora);
              let aux = calculoHora(bitacora.FechaUltimoReporte);

              return (
                <>
                  <div
                    key={index}
                    className="card p-t-10 row animated slideInLeft delay-1-1s"
                    id="elementChanging"
                  >
                    <div className="col-md-12 col-12 no-margin no-padding">
                      <div className="row rute">
                        <div className="col-md-5 col-5 no-margin no-padding">
                          <span className="in-left m-l-20">
                            <img
                              className="m-t-5"
                              src={truckDark}
                              alt="camion"
                              width="30%"
                            />
                          </span>
                          <p>{bitacora.numero_unidad}</p>
                        </div>
                        <div className="col-md-7 col-7 no-margin no-padding">
                          <span className="m-r-20 pull-right text-hour">
                            <small>
                              Ult. Mov:{" "}
                              {bitacora.FechaUltimoReporte
                                ? formatDate(bitacora.FechaUltimoReporte)
                                : "S/D"}
                            </small>
                            <span
                              className="translate-middle p-1 border border-light ms-1"
                              style={{ background: `${aux}`, borderRadius: 5 }}
                            ></span>
                          </span>
                          <span className="in-left ">
                            <img
                              className="m-t-5"
                              alt=""
                              src={storeDark}
                              width="30%"
                            />
                          </span>
                          <p>{bitacora.CEDIS}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`col-md-12 col-12 m-t-20 m-b-20 no-padding ${
                        user.rol !== "S.W.A.T" ? "cursor" : ""
                      }`}
                      style={{ height: "100px" }}
                      onClick={() => {
                        if (user.rol != "S.W.A.T") {
                          getDetails(bitacora.unidad_id, bitacora.id_viaje);
                        } else {
                          console.log("Es rol S.W.A.T");
                        }
                      }}
                    >
                      <ul className="progress-indicator">
                        {bitacora.bitacoras.map((bit) => {
                          return (
                            <>
                              <li
                                className="progress-bar-icon mb-5"
                                style={{ backgroundColor: bit.color }}
                                key={bit.status_id}
                              >
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "white",
                                    marginTop: "-0.5rem",
                                  }}
                                >
                                  {/* Contenedor relativo para posicionar el ícono y el contador */}
                                  <span
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className={
                                        bit.icon
                                          ? bit.icon
                                          : "fa-solid fa-question"
                                      }
                                      style={{
                                        backgroundColor: bit.color,
                                        borderRadius: "3rem",
                                        paddingTop: "5px",
                                        height: 30,
                                        width: 30,
                                      }}
                                      title={bit.notas}
                                    ></i>

                                    {/* Contador como span */}
                                    {bit.contador > 1 && (
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "-5px",
                                          right: "-10px", // Movido más a la derecha
                                          backgroundColor: "red",
                                          color: "white",
                                          borderRadius: "50%",
                                          padding: "2px 5px",
                                          fontSize: "9px",
                                          fontWeight: "bold",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {`${bit.contador}+` || 0}
                                      </span>
                                    )}
                                  </span>
                                </p>
                                <p className="mb-0">
                                  <small
                                    style={{
                                      fontSize: "12px",
                                      color: "black",
                                      fontWeight: 900,
                                    }}
                                  >
                                    {bit.nombre}
                                  </small>
                                  <br></br>
                                  <small
                                    style={{
                                      fontSize: "12px",
                                      color: bit.color || "black",
                                      fontWeight: 900,
                                    }}
                                  >
                                    {moment(bit.fecha_hora).format("lll")}
                                  </small>
                                </p>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </div>
                    <div className="col-md-12 col-12 no-margin no-padding">
                      <div className="row rute">
                        <div className="col-3 text-center">
                          <FontAwesomeIcon title={bitacora.flujo_id === 2 ? "Unidad en Viaje Automatico" : "Unidad en Viaje Manual"} style={{color: "green"}} icon={faPaperPlane}></FontAwesomeIcon> &nbsp; {bitacora.flujo_id === 2 ? "VA" : "VM"}
                        </div>
                        {
                          (user.roles_id !== 6 && user.roles_id !== 8) && (
                            <>
                              <div className="col-3 text-center">
                                {/* Nuevo enlace para el SideCard de Protocolo (lado izquierdo) */}
                                <a
                                  style={{ cursor: "pointer" }} // Añadir margen para separar
                                  onClick={() => handleShowSideCardLeft(bitacora)} // Pasa el item de bitácora completo
                                  title="Ver Protocolo de Seguridad del CEDIS"
                                >
                                  <FontAwesomeIcon icon={faFileLines} /> &nbsp;
                                  Protocolo
                                </a>
                              </div>
                            </>
                          )
                        }

                        <div className="col-3 text-center">
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setActiModalHistEvents(true);
                              setIdViaje(bitacora.id_viaje);
                            }}
                          >
                            <FontAwesomeIcon icon={faList} /> &nbsp; Histórico
                            de eventos
                          </a>
                        </div>

                        <div className="col-3 text-center">
                          {bitacora.evento_riesgo === 1 &&
                          user.rol === "S.W.A.T" ? (
                            <>
                              <div
                                id="liveToastBtn"
                                className="col-md col "
                                style={{
                                  fontSize: "0.7em",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                  color: "red",
                                }}
                                onClick={() => {
                                  setActiModal(true);
                                  setIdUnidad(bitacora.unidad_id);
                                }}
                              >
                                <FontAwesomeIcon icon={faUserSecret} /> &nbsp;
                                ACTUALIZAR EVENTO
                              </div>
                            </>
                          ) : bitacora.evento_riesgo === 1 ? (
                            <>
                              <div className="row">
                                <div
                                className="col-6"
                                style={{
                                  fontSize: "0.7em",
                                  fontWeight: "bold",
                                  color: "red",
                                }}
                              >
                                <FontAwesomeIcon icon={faUserSecret} /> &nbsp;
                                EVENTO DE SEGURIDAD ACTIVO
                                </div>
                                <div
                                  className="col-2"
                                  style={{
                                    zIndex: 10,
                                    cursor: "pointer"
                                  }}
                                  onClick={() => copiarMensaje(bitacora.evento_seguridad_id)}
                                  title="Copiar información de evento de riesgo"
                                >
                                  <div className="copy-icon" style={{ height: "14px"}}>
                                    <FontAwesomeIcon icon={faFileLines} />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </>
              );
            })
          ) : (
            <h5 className="text-center p-2">
              No hay unidades que mostrar.{" "}
              {form.status_id && "No hay ultimo evento"}
            </h5>
          )}
        </div>
      </div>
      {/* <CToaster ref={toaster} push={toast} placement="middle-end" /> */}
      {actiModal ? (
        <RegistrarEditarEventoRoboCamiones
          idUnidad={idUnidad}
          mostrarModal={actiModal}
          onAction={modalClose}
          viaje={viaje}
          eventAction={"EDITAR"}
        />
      ) : (
        ""
      )}
      {actiModalHistEvents ? (
        <HistoricoEventosViaje
          idViaje={idViaje}
          mostrarModal={actiModalHistEvents}
          onAction={modalCloseHistEvents}
          isLoaded={isLoaded}
        />
      ) : (
        ""
      )}
      {/* Renderizar el SideCard izquierdo para Protocolos */}
      <SideCard
        show={showSideCardLeft}
        onHide={handleHideSideCardLeft}
        protocoloData={sideCardLeftProtocolData}
        placement="start" // Esto hace que se abra desde la izquierda
      />
    </>
  );
};
